import dateTime from './date-time.js';

export default {
    install: function(Vue){
        Vue.filter('dateTime', dateTime);
    }
}